import {DEFAULT_INTEREST} from "../constants/calculations_defaults";
import {getInstalmentRangesFromName} from "../constants/InstallmentCalculatorRangesOptions";
import {RangeOptionNameType} from "../types/RangeOptionNameType";

export const calculateInstallment = (price: number, contribution: number, period: number) => {
    if (!price || !contribution || !period) {
        return null;
    }
    let usePrice = price;
    let useContribution = contribution;

    const {min: priceMin, max: priceMax} = getInstalmentRangesFromName(RangeOptionNameType.PRICE);
    const {min: contributionMin, max: contributionMax} = getInstalmentRangesFromName(RangeOptionNameType.CONTRIBUTION);

    if (price < priceMin) {
        usePrice = priceMin;
    }

    if (price > priceMax) {
        usePrice = priceMax;
    }

    if (contribution < contributionMin) {
        useContribution = contributionMin;
    }

    if (contribution > contributionMax) {
        useContribution = contributionMax;
    }

    /**
     * R=A*b/m*(1-(m/m+b)^n),
     *  R is the installment amount,
     *  A is the amount of credit granted,
     *  b is the interest rate on the loan per year - we assume 7%,
     *  m is the number of installments to pay in a year,
     *  n is the number of installments
     */
    const credit = usePrice - (usePrice * useContribution) / 100;
    const instalmentsNumber = period * 12;
    const instalmentsPerYear = 12;

    return Math.ceil(
        (credit * DEFAULT_INTEREST) / (instalmentsPerYear * (1 - Math.pow(instalmentsPerYear / (instalmentsPerYear + DEFAULT_INTEREST), instalmentsNumber)))
    );
};
